const styles = () => ({
  root: {
    paddingLeft: 8,
    paddingRight: 8,
  },

  header: {
    paddingTop: 8,
    display: 'flex',
  },

  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    marginBottom: 20,
  },

  title: {
    fontSize: 15,
    fontWeight: 500,
    color: '#27282a',
  },

  subTitle: {
    fontSize: 14,
    color: '#596168',
  },

  separator: {
    borderTop: '1px solid #e7e8e9',
    border: 0,
    height: 1,
    width: '100%',
  },

  grid: {
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    gridGap: 36,
    marginTop: 20,
  },

  destinationItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 16,
  },

  logo: {
    marginRight: 12,
    width: 30,
    height: 30,
  },

  destinationTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },

  destinationTitle: {
    color: '#27282a',
    fontSize: 16,
    fontWeight: 500,
  },

  destinationSubtitle: {
    fontSize: 14,
    color: '#596168',
  },

  footer: {
    display: 'flex',
    alignItems: 'center',
    margin: '19px 0 8px 0',
  },

  footerServiceIcon: {
    width: 16,
    height: 16,
    '& + &': {
      marginRight: 8,
    },
  },

  footerText: {
    fontSize: 14,
    marginLeft: 9,
    position: 'relative',
    top: 1,
  },
});

export default styles;
